import { useLocalization } from '@/hooks/useLocalization';
import { getHome } from '@/services/content';
import { useQuery } from '@tanstack/react-query';
import { CMSSectionsResponse } from '@/services/utilities.service';

export function getFindSectionsQueryOptions(
  hash: string,
  deliveryType?: string,
) {
  return {
    queryKey: ['home', { hash, deliveryType }],
    queryFn: () => getHome(hash, deliveryType),
  };
}

export function useFindSectionsQuery() {
  const { hash, deliveryType } = useLocalization();
  return useQuery<CMSSectionsResponse>(
    getFindSectionsQueryOptions(hash, deliveryType),
  );
}
